import { FC, PropsWithChildren, createContext, useCallback, useContext, useEffect, useState } from 'react';
import * as API from 'services/damage-options';
import { ChassisDamageTypes, ContainerDamageTypes } from 'types';
import { DamageOption } from "types/damage/damage-types";
import { useSelectedLocation } from './selected-location';


type DamageOptionContextType = {
    damageOptionList: DamageOption[];
    containerDamageMap: ContainerDamageTypes,
    chassisDamageMap: ChassisDamageTypes,
    gensetDamageList: string[],
    saveDamageOption: (damageOption: DamageOption) => void;
    deleteDamageOptions: (ids: number[]) => void;
};

export const DamageOptionContext = createContext<DamageOptionContextType>({
    damageOptionList: [],
    containerDamageMap: {} as ContainerDamageTypes,
    chassisDamageMap: {} as ChassisDamageTypes,
    gensetDamageList: [],
    saveDamageOption: () => {},
    deleteDamageOptions: () => {}
});

export const useDamageOptions = () => useContext(DamageOptionContext);

export const DamageOptionProvider: FC<PropsWithChildren> = ({ children }) => {
    const [damageOptionList, setDamageOptionList] = useState<DamageOption[]>([]);
    const [containerDamageMap, setContainerDamageMap] = useState<ContainerDamageTypes>({} as ContainerDamageTypes)
    const [chassisDamageMap, setChassisDamageMap] = useState<ChassisDamageTypes>({} as ChassisDamageTypes)
    const [gensetDamageList, setGensetDamageList] = useState<string[]>([])
    const { selectedLocation } = useSelectedLocation();

    useEffect(() => {
        if(selectedLocation?.id) {
            API.getDamageOptionList(selectedLocation?.id).then(setDamageOptionList);
            API.getContainerDamage(selectedLocation?.id).then(setContainerDamageMap);
            API.getChassisDamage(selectedLocation?.id).then(setChassisDamageMap);
            API.getGensetDamage(selectedLocation?.id).then(setGensetDamageList);
        }
    }, [selectedLocation]);

    const saveDamageOptionRequest = useCallback((damageOption: DamageOption) => {
        API.saveDamageOption(damageOption, selectedLocation?.id).then(dOpt => dOpt && setDamageOptionList([ ...damageOptionList, dOpt ]))
      },
      [damageOptionList]
    );

    const deleteDamageOptions = useCallback(async (deleteIds: number[]) => {

        const deletedIds: number[] = [];
        for(const deleteId of deleteIds) {
            await API.deleteDamageOption(deleteId);
            deletedIds.push(deleteId);
        }
        setDamageOptionList(damageOptionList.filter(val => !deletedIds.includes(val.id as any)));
      },
      [damageOptionList]
    );

    const getContainerDamageOptionMap = useCallback

    return (
        <DamageOptionContext.Provider
            value={{
                damageOptionList,
                containerDamageMap,
                chassisDamageMap,
                gensetDamageList,
                saveDamageOption: saveDamageOptionRequest,
                deleteDamageOptions
            }}
        >
            {children}
        </DamageOptionContext.Provider>
    );
}